const dev = {
  testTenant: {
    title: 'Testseite für das Mandantensystem',
    domainTitle: 'Domain-Informationen',
    domainDescription: 'Aktuelle Ergebnisse der Domain-Auflösung',
    hostname: 'Hostname:',
    subdomain: 'Subdomain:',
    isCustomDomain: 'Eigene Domain:',
    isLocalhost: 'Lokale Umgebung:',
    baseDomain: 'Basisdomain:',
    providerTitle: 'Provider-Informationen',
    providerDescription: 'Aufgelöste Provider-Daten der Domain',
    providerId: 'Provider-ID:',
    providerName: 'Provider-Name:',
    providerSlug: 'Provider-Slug:',
    providerDomain: 'Provider-Domain:',
    customDomains: 'Eigene Domains:',
    noProvider: 'Kein Provider geladen',
    brandingTitle: 'Branding-Informationen',
    brandingDescription: 'Provider-Branding und Anpassung',
    primaryColor: 'Primärfarbe:',
    secondaryColor: 'Sekundärfarbe:',
    theme: 'Theme:',
    logo: 'Logo:',
    noBranding: 'Kein Branding konfiguriert',
    quickTestsTitle: 'Schnelltests',
    quickTestsDescription: 'Teste verschiedene Provider und Funktionen',
    providerLinksHeading: 'Provider-Links:',
    refreshHeading: 'Tenant-Daten aktualisieren:',
    refreshButton: 'Provider aktualisieren',
  },
} as const

export default dev
